// extracted by mini-css-extract-plugin
module.exports = {"sidePanel":"SidePanel_sidePanel__3MaJj","left":"SidePanel_left__1Kdyp","right":"SidePanel_right__3hH93","closeBtn":"SidePanel_closeBtn__6Kxwc"};